import { faClockFour } from "@fortawesome/free-regular-svg-icons";
import { faAngleRight, faDesktop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { dateFormatter } from "../_helpers/dateFormatter";
import CustomImage from "../_components/Common/CustomImage";

export const ScheduledEventsCard = ({
  eventDetails,
  onJoinHmsClick,
  isPastEvent,
}) => {
  const getJoineeName = () => {
    const user_token =
      localStorage.getItem("jigsawUser") &&
      JSON.parse(localStorage.getItem("jigsawUser"));
    return user_token?.user &&
      user_token.user.full_name === eventDetails?.event_creator
      ? eventDetails?.joinee && eventDetails.joinee?.full_name
        ? eventDetails.joinee.full_name
        : eventDetails.joinee.name
      : eventDetails?.event_creator;
  };
  return (
    <div className="bg-grey-4 border rounded-lg p-3 cursor-pointer mb-2">
      <div className=" d-flex align-items-start justify-content-between ">
        <div className="left">
          <div className="d-flex">
            <CustomImage
              src="/assets/images/calendar.svg"
              height={"20px"}
              width={"20px"}
              className="text-grey-4"
            />
            <p className="fs-smallest text-grey-4 mb-1 ml-1 d-inline-block">
              {dateFormatter(
                eventDetails?.interview && eventDetails.interview.interview_date
              )}
            </p>
          </div>
          <FontAwesomeIcon icon={faClockFour} className="text-grey-4 mr-2" />
          <p className="fs-smallest text-grey-4 mb-1 d-inline-block">
            {eventDetails?.interview && eventDetails.interview?.local_timezone &&
              eventDetails.interview.local_timezone?.start_time &&
              eventDetails.interview.local_timezone.start_time.slice(0 , 5)}{" "}
            -{" "}
            {eventDetails?.interview &&  eventDetails.interview?.local_timezone &&
              eventDetails.interview.local_timezone?.end_time &&
              eventDetails.interview.local_timezone.end_time.slice(0 , 5)}{" "}{""}
              <span>{eventDetails?.interview &&  eventDetails.interview?.local_timezone &&
              eventDetails.interview.local_timezone?.timezone}</span>
          </p>
          <div className="font-weight-medium mb-0 fs-14">
            Face to Face Interview{" "}
            <span className="text-grey-4 font-weight-400">with</span>{" "}
            {getJoineeName()}
            {eventDetails?.interview &&
              eventDetails.interview.job_details ?
              <>
                <span className="text-grey-4 font-weight-400">{" "}
                  for</span>{" "}
                <span className="text-capitalize">
                  {eventDetails?.interview &&
                    eventDetails.interview.job_details?.title}
                </span>
              </>
              : null}
          </div>
        </div>
        {isPastEvent ? (
          <p
            className="ml-3"
            onClick={() =>
              onJoinHmsClick(
                eventDetails?.interview && eventDetails.interview?.id,
                eventDetails?.interview && eventDetails.interview?.hms_room_id
              )
            }
          >
            <CustomImage
              src="/assets/images/vid-share-screen.svg"
              height={"20px"}
              width={"20px"}
              className="text-grey-4"
            />
          </p>
        ) : (
          <FontAwesomeIcon
            icon={faAngleRight}
            className="text-grey-4 mx-3 mb-1"
          />
        )}
      </div>
    </div>
  );
};
